import { render, staticRenderFns } from "./setMaklumatPegGaji.vue?vue&type=template&id=f5172a48&"
import script from "./setMaklumatPegGaji.vue?vue&type=script&lang=js&"
export * from "./setMaklumatPegGaji.vue?vue&type=script&lang=js&"
import style0 from "./setMaklumatPegGaji.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports